import { storeConfig } from "@/config/storeConfig";
import { panelModes } from "@/mocks/panelContent";
import { FieldRow, LockedButton, PanelBadge, PanelCard, ReadOnlyNotice } from "../components/PanelUI";

const sampleMessage = `🛍️ NOVO PEDIDO | AMORA BELLE
Pedido: AMB-PED-00001

👤 CLIENTE
Nome: Maria Silva
WhatsApp: (62) 99999-9999

📦 PEÇAS ESCOLHIDAS

1. Blusa Essencial Sofia
   Código: AMB-BLU-001
   Cor: Rosa queimado
   Tamanho: M
   Quantidade: 1
   Valor unitário: R$ 119,90
   Subtotal: R$ 119,90

2. Calça Alfaiataria Helena
   Código: AMB-CAL-001
   Cor: Marrom café
   Tamanho: 40
   Quantidade: 1
   Valor unitário: R$ 259,90
   Subtotal: R$ 259,90

🚚 RECEBIMENTO
Modalidade: Entrega local
Prazo apresentado: até 2 dias úteis
Taxa: R$ 15,00

💰 RESUMO
Quantidade de peças: 2
Produtos: R$ 379,80
Desconto: R$ 0,00
Frete: R$ 15,00
Total estimado: R$ 394,80

A disponibilidade, o prazo, o frete e a forma de pagamento serão confirmados no atendimento.

Pedido iniciado pelo site Amora Belle — modelo demonstrativo da Vellora Studio.`;

export default function WhatsAppSection() {
  return (
    <div className="flex flex-col gap-6">
      <ReadOnlyNotice text={panelModes.viewNotice} />

      <PanelCard
        title="WhatsApp"
        description="Configuração do atendimento e modelo da mensagem do pedido."
        action={<PanelBadge tone="primary">Ativo</PanelBadge>}
      >
        <div className="grid grid-cols-1 gap-x-8 lg:grid-cols-2">
          <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
            <FieldRow label="Número para pedidos" value={storeConfig.whatsappNumber} />
            <FieldRow label="Exibição do número" value={storeConfig.whatsappDisplay} />
            <FieldRow label="Link de atendimento" value="wa.me/message/6X77HRWZGKPQH1" />
            <FieldRow label="Formato do pedido" value="wa.me/5562998023960?text=MENSAGEM_CODIFICADA" />
            <FieldRow label="Origem registrada" value={storeConfig.origin} />
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-xs leading-relaxed text-foreground-600">
              O link de atendimento abre apenas para dúvidas. A finalização da compra usa a mensagem
              completa abaixo, gerada automaticamente com todos os dados do pedido.
            </p>
            <LockedButton icon="ri-edit-2-line">Editar configuração do WhatsApp</LockedButton>
          </div>
        </div>
      </PanelCard>

      <PanelCard
        title="Modelo da mensagem"
        description="Uma linha por informação, com todos os produtos, códigos, cores, tamanhos e valores."
      >
        <pre className="max-h-[520px] overflow-auto whitespace-pre-wrap rounded-lg border border-background-200 bg-background-100 p-4 text-xs leading-relaxed text-foreground-800">
{sampleMessage}
        </pre>
      </PanelCard>
    </div>
  );
}